import { qweGuid } from "../../common/commonHelper"

interface ProxyLoader {
  loadCss(src: string): any;
  loadScript(src: string): Promise<any>;
  loadScriptConcurrent(src: Array<string>): Promise<any>;
}

class loaderProxy implements ProxyLoader {
  constructor() {}

  protected scriptLoaderCache: Map<string,string> = new Map<string,string>();
  protected cssLoaderCache: Map<string,string> = new Map<string,string>();

  public loadCss = (src: string): any => {
    if (this.cssLoaderCache.has(src)) {
      return src;
    } else {
      let id = qweGuid(10);
      const element: HTMLLinkElement = document.createElement("link");
      element.rel = "stylesheet";
      element.id = id;
      element.href = src;
      document.body.appendChild(element);
      element.onload = () => {
        return this.cssLoaderCache.set(src,id);
      };
    }
  };

  public uninstallCss = (src: string): any => {
    if (this.cssLoaderCache.has(src)) {
      let id = this.cssLoaderCache.get(src) || "";
      let element = document.getElementById(id);
      if(element != undefined || element != null){
        document.body.removeChild(element);
      }
    } else {
      return src;
    }
  };

  // public loadScript =  async (src: string): Promise<any> => {
  //   if (this.scriptLoaderCache.has(src)) {
  //      return Promise.resolve();
  //   } else {
  //     let id = qweGuid(10);
  //     const element: HTMLScriptElement = document.createElement("script");
  //     element.src = src;
  //     element.id = id;
  //     document.body.appendChild(element);
  //     element.onload = () => {
  //        this.scriptLoaderCache.set(src,id);
  //        return Promise.resolve()
  //     };
  //   }
  // };

  public loadScriptConcurrent = (
    srcList: Array<string>
  ): Promise<any> => {
    let that = this;
    return new Promise(function (resolve, reject) {
        if (Array.isArray(srcList)) {
             let allTask = new Array();
             srcList.forEach(src => {
               allTask.push(that.loadScript(src));
             });
             try{
                Promise.all(allTask)
                .then(x=> 
                  resolve(x)
                )
                .catch(()=> 
                  reject()
                )
             }
             catch(e){
               console.log(e)
             }
        }
        else{
           resolve(srcList);
        }
    });
  };

  public loadScript = (
    src: string
  ): Promise<any> =>{
     let that = this;
     return new Promise(function (resolve, reject) {
      if (that.scriptLoaderCache.has(src)) {
         resolve(src);
      } else {
        let id = qweGuid(10);
        const element: HTMLScriptElement = document.createElement("script");
        element.src = src;
        element.id = id;
        document.body.appendChild(element);
        element.onload = () => {
          that.scriptLoaderCache.set(src,id)
          resolve(src);
        };
        element.onerror = (e)=> {
          reject(e);
        }
      }
     })
  }
}

export const loader = new loaderProxy();
